import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Transformation from "./components/Transformation";
import Trainer from "./components/Trainer";
import Roadmap from "./components/Roadmap";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import ExitIntent from "./components/ExitIntent";
import ThankYou from "./components/ThankYou";
import SEO from "./components/SEO";
import Tracking from "./components/Tracking";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundPolicy from "./pages/RefundPolicy";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";

const Landing = () => (
    <div className="App" id="top" data-testid="app-root">
        <SEO path="/" />
        <Nav />
        <main>
            <Hero />
            <Transformation />
            <Trainer />
            <Roadmap />
            <Testimonials />
            <Pricing />
            <FAQ />
        </main>
        <Footer />
        <ExitIntent />
    </div>
);

const ThankYouRoute = () => (
    <>
        <SEO
            path="/thank-you"
            title="Thank You — Your Seat Is Reserved"
            description="You're in. Welcome to Grads2Pro. Your live enterprise networking workshop starts soon."
        />
        <ThankYou />
    </>
);

function App() {
    return (
        <BrowserRouter>
            <Tracking />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/thank-you" element={<ThankYouRoute />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="*" element={<Landing />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
